import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import cn from '@/utils/cn';
import AISafetyReport from '../SysadminSPA/DevView/AISafety/AISafetyReport';
import { SPAThemeScope } from '../SysadminSPA/shared/SPAThemeScope';

// AIDEV-NOTE: The SPA's AI Safety page mounted on the legacy /admin/ai_safety_reports page, the way
// admin/UserSearch is. The legacy chrome is light, so the SPA tokens are pinned to their light set
// here (.spa-theme-light in _sysadmin_spa.scss) whatever the SPA theme selector says. SPAThemeScope
// carries the same class to portalled surfaces (the failure dialog), which render outside this tree.
//
// The ground bleeds the full viewport width the way UserSearchPage's does: the layout caps the
// content column, so a huge box-shadow paints the ground sideways and clip-path trims it vertically.
const THEME_CLASS = 'spa-theme-light';

const groundClasses = cn(
  THEME_CLASS,
  'tw-box-border tw-min-h-[calc(100vh-5.875rem)] tw-bg-spa-bg tw-text-spa-on-bg',
  'tw-shadow-[0_0_0_100vmax_var(--spa-bg)]',
);

const LegacyAISafetyReport = () => (
  <ReactQueryProvider>
    <BrowserRouter basename="/admin/ai_safety_reports">
      <SPAThemeScope className={THEME_CLASS}>
        <div className={groundClasses} style={{ clipPath: 'inset(0 -100vmax)' }}>
          <AISafetyReport />
        </div>
      </SPAThemeScope>
    </BrowserRouter>
  </ReactQueryProvider>
);

export default LegacyAISafetyReport;
